// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeDescription_container__s1QM5","content":"RecipeDescription_content__TByuF"};